import React, { ComponentProps } from "react";

function GoalTipBulbIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.37865 10.4249H7.60118C7.78319 10.4249 7.9223 10.279 7.9223 10.1015C7.9223 9.92632 7.78319 9.78125 7.60118 9.78125H4.37865C4.19664 9.78125 4.05341 9.92632 4.05341 10.1015C4.05341 10.279 4.19664 10.4249 4.37865 10.4249ZM5.9883 11.9166C6.78303 11.9166 7.42366 11.5304 7.47663 10.9465H4.49868C4.53836 11.5304 5.18855 11.9166 5.9883 11.9166Z"
        fill="white"
      />
      <path
        d="M2.57141 3.1516C2.57141 5.06117 3.82217 5.6016 4.0082 8.87824C4.01824 9.11331 4.17213 9.26044 4.4154 9.26044H7.56118C7.8086 9.26044 7.95744 9.11331 7.97253 8.87824C8.15853 5.6016 9.4061 5.06211 9.4061 3.15251C9.4061 1.37551 7.88925 0 5.9883 0C4.08735 0 2.57141 1.37461 2.57141 3.1516Z"
        fill="white"
      />
    </svg>
  );
}

export default GoalTipBulbIcon;
